import Vue from 'vue'

export const NotifierBus = new Vue({HasSubscribers: false})



// WEBPACK FOOTER //
// ./src/store/eventbusses.js